import { computed, observable, makeObservable } from 'mobx';

import type { DiagnosisParams } from 'chaika-frontend-types/frontend-cms';
import { MedicalCaseStatus, DiagnosisType } from 'chaika-enums';

export enum DiagnosisStatus {
    Opened = 'opened',
    Closed = 'closed',
    Changed = 'changed',
}

export interface DetailsDetailsParams {
    ehrId?: number;
    statuses: DiagnosisStatus[];
    title: string;
    entryId: string;
    author: string;
    creationTime: string;
}

export interface MedicalCaseParams {
    ehrId?: number;
    title?: string;
    description: string;
    details: DetailsDetailsParams[];
    author: string;
    creationTime: string;
}

export class Diagnosis {
    @observable public id: string;
    @observable public medicalCaseId: string;
    @observable public type: DiagnosisType;
    @observable public status: MedicalCaseStatus;
    @observable public icdId: string;
    @observable public clinicalDiagnosis: string;

    constructor({ medicalCaseId, type, status, icdId, clinicalDiagnosis }: DiagnosisParams) {
        makeObservable(this);

        this.id = medicalCaseId;
        this.medicalCaseId = medicalCaseId;
        this.type = type;
        this.status = status;
        this.icdId = icdId;
        this.clinicalDiagnosis = clinicalDiagnosis;
    }

    @computed
    public get isClose(): boolean {
        return this.status === MedicalCaseStatus.Closed;
    }

    public serialize(): DiagnosisParams {
        return {
            medicalCaseId: this.medicalCaseId,
            type: this.type,
            status: this.status,
            icdId: this.icdId,
            clinicalDiagnosis: this.clinicalDiagnosis,
        };
    }
}
